export const DOCUMENT_STATUS = {
  PENDING: 0,
  PROCESSING: 1,
  COMPLETED: 2,
  ERROR: 3,
} as const;

export const DOCUMENT_TYPE = {
  UNKNOWN: 0,
  LIEN: 1, // Freeze
  AMENDMENT: 2,
  LIEN_RELEASE: 3, // Release
} as const;

export interface Document {
  lookup: string;
  referenceTo?: string;  
  frozenDeedReference?: string;
  parentReference?: string;
  accessorId?: number;
  countyId?: number;
  stateId?: number;
  deleted: boolean;
  void: boolean;
  generated: boolean;
  status?: number;
  statusNote?: string;
  filedDate?: string;
  generatedDate?: string;
  fileId?: number;
  type: typeof DOCUMENT_TYPE[keyof typeof DOCUMENT_TYPE];
  freezeId?: number;
  createdDate: string;
  updatedDate: string;
  paid?: boolean;
  freezeLookup?: string;
  customData?: Record<string, any>;
}

export interface CreateDocumentRequest {
  reference?: string;
  lookup: string;
  accessorId?: number;
  countyId?: number;
  stateId?: number;
  type?: typeof DOCUMENT_TYPE[keyof typeof DOCUMENT_TYPE];
  filedDate?: string;
  generatedDate?: string;
  fileId?: number;
  freezeId?: number;
  deleted?: boolean;
  void?: boolean;
  generated?: boolean;
  customData?: Record<string, any>;
}

export interface DocumentResponse {
  success: true;
  data: Document;
}

export interface DocumentListResponse {
  success: true;
  data: Document[];
  total: number;
}

export interface DocumentAttribute {
  id: number;
  reference?: string;
  documentId: number;
  key: string;
  value?: string;
}

export type CreateDocumentAttributeRequest = Omit<DocumentAttribute, 'id'>;
export type UpdateDocumentAttributeRequest = Partial<CreateDocumentAttributeRequest>;

export interface DocumentAttributeResponse {
  success: boolean;
  data: DocumentAttribute;
}

export interface DocumentAttributeListResponse {
  success: boolean;
  data: DocumentAttribute[];
  total: number;
}

export type UpdateDocumentRequest = Partial<CreateDocumentRequest>; 